export default __webpack_public_path__ + "static/media/night.3c850769.png";